import character1 from "../../images/roadmap/roadmap1.jpeg";
import character2 from "../../images/roadmap/roadmap2.jpeg";
import character3 from "../../images/roadmap/roadmap3.jpeg";
import character4 from "../../images/roadmap/roadmap4.jpeg";
import character5 from "../../images/roadmap/roadmap5.jpeg";
import character6 from "../../images/roadmap/roadmap6.jpeg";

const data = [
  character1,
  character2,
  character3,
  character4,
  character5,
  character6,
  character3,
];

export default data;
